import { render, staticRenderFns } from "./ListViewRoofStructure.vue?vue&type=template&id=b877323e"
import script from "./ListViewRoofStructure.vue?vue&type=script&lang=ts"
export * from "./ListViewRoofStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports